import { createContext,useContext } from "react";

const PageInfoContext = createContext()

export const PageInfoProvider = PageInfoContext.Provider

export const usePageInfoProvider = () => useContext(PageInfoContext)
